// backend -> frontend contract: the phrase a guarded regeneration route replies with when nothing was dirty
export const ALREADY_UP_TO_DATE_PATTERN = /already up to date/i;

/**
 * Classify a resolved update-stream terminal frame into the outcomes a regeneration preview
 * flow reacts to: "failure" (error or unsuccessful), "upToDate" (skipped, nothing to regenerate),
 * or "success".
 * @param {object} result
 */
export const classifyPreviewStreamResult = (result) => {
  if (!result || result.error) return "failure";
  if (ALREADY_UP_TO_DATE_PATTERN.test(result.message || "")) return "upToDate";
  return result.success ? "success" : "failure";
};
